
import React from 'react';
import { connect } from 'react-redux';
import WorkItem from 'components/Work/WorkItem/WorkItem';
import * as ConfigTypes from 'config/ConfigTypes';

import { Flow } from 'flow-react';
import { observer } from 'mobx-react';

import * as actions from 'store/actions';

import './WorkList.scss';

const WorkList = observer(
    class WorkList extends React.Component {
        constructor(props) {
            super(props);
            this.state = {
                worklist: []
            }
        }

        updateWorkList = () => {
            const { worklist } = this.props.mediaObjects;
            // if (worklist && worklist.length) {
            if (worklist) {
                this.setState({ worklist: worklist });
            }
        }

        showWorkList = (item, i) => {
            if (this.props.mediaObjects.viewMode == ConfigTypes.LIST) {
                return (<WorkItem key={`worklistCard_${i}`} work={item} />)
            }
            return (<WorkItem key={`worklistCard_${i}`} work={item} />)
        }

        showList = () => {
            if (this.props.mediaObjects.viewMode == ConfigTypes.LIST) {
                return (
                    <div className="worklist-list list-group">
                        <ul>
                            {this.state.worklist.map((item, i) => this.showWorkList(item, i))}
                        </ul>
                    </div>
                )
            }
            return (
                <div className="row worklist-grid">
                    {this.state.worklist.map((item, i) => this.showWorkList(item, i))}
                </div>
            )
        }

        componentDidUpdate(prev) {
            if (prev.mediaObjects.worklist != this.props.mediaObjects.worklist) {
                this.updateWorkList();
            }
        }

        componentDidMount() {
            this.updateWorkList();
        }

        render() {
            return (
                <div className="worklist">
                    {this.showList()}
                </div>
            )
        }
    }
)

const mapStateToProps = (state) => ({
    mediaObjects: state.media.mediaObjects
});

const mapDispatchToProps = (dispatch) => ({
    updateMediaObjects: (obj) => dispatch(actions.updateMediaObjects(obj)),
    updateAppObjects: (obj) => dispatch(actions.updateAppObjects(obj)),
})

export default Flow.injectFlow(connect(mapStateToProps, mapDispatchToProps)(WorkList));